"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdTabletop = _interopRequireDefault(require("cccisd-tabletop"));
var _messageLogByMessage = _interopRequireDefault(require("./messageLogByMessage.graphql"));
var _messageLogByRecipient = _interopRequireDefault(require("./messageLogByRecipient.graphql"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _warning = _interopRequireDefault(require("cccisd-icons/warning2"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var messageLogTable = function messageLogTable() {
  var byMessage = {
    query: _messageLogByMessage["default"],
    rowKey: 'messageId',
    isAscentOrder: false,
    handle: 'messageLogByMessage',
    columns: [{
      name: 'attemptedAt',
      label: 'Date',
      sort: true,
      filter: true,
      filterSettings: {
        type: 'date'
      },
      width: '170px'
    }, {
      name: 'messageType',
      label: 'Type',
      sort: true,
      filter: true
    }, {
      name: 'status',
      label: 'Status',
      sort: true,
      filter: true,
      render: function render(_ref) {
        var row = _ref.row;
        if (row.statusMessage != null && (row.status.toLowerCase() === 'failed' || row.status.toLowerCase() === 'failure')) {
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, row.status, "\xA0", /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
            title: row.statusMessage
          }, /*#__PURE__*/_react["default"].createElement(_warning["default"], null)));
        }
        return row.status;
      }
    }, {
      name: 'action',
      label: 'Action',
      sort: true,
      filter: true
    }, {
      name: 'pawn.user.username',
      label: 'Username',
      sort: true,
      filter: true,
      tooltip: /*#__PURE__*/_react["default"].createElement("div", null, "If the recipient is a user in the system, the username is shown.", /*#__PURE__*/_react["default"].createElement("div", null, "If not, we are rendering ", /*#__PURE__*/_react["default"].createElement("i", null, "Sent To:"), " and the email address of the recipient."), /*#__PURE__*/_react["default"].createElement("div", null, "Sorting and filtering on this column is not exact.")),
      render: function render(_ref2) {
        var row = _ref2.row;
        var messageSentTo = function messageSentTo() {
          var header = row['messageInfo.headers'];
          if (header && header.includes('To:') && header.includes('MIME-Version:')) {
            return header.substring(header.indexOf('To:') + 3, header.lastIndexOf('MIME-Version:'));
          }
          var to = row['messageInfo.to'];
          if (to) {
            return to;
          }
          return 'Missing ' + (row.messageType === 'email' ? 'Email Address' : 'Phone Number');
        };
        return row['pawn.user.username'] ? row['pawn.user.username'] : "Sent To: ".concat(messageSentTo());
      },
      filterSettings: {
        type: 'regex',
        field: 'messageInfo.headers',
        preparePattern: function preparePattern(value) {
          return "\"[^\"]*".concat(value);
        }
      }
    }, {
      name: 'pawn.pawn.pawnId',
      label: 'Recipient ID',
      sort: true,
      filter: true
    }, {
      name: 'pawn.pawn.roleName',
      label: 'Role',
      sort: true,
      filter: true
    }, {
      name: 'pawn.parentGroup.anyGroup.group.label',
      label: 'Group',
      sort: true,
      filter: true
    }]
  };
  var byRecipient = {
    query: _messageLogByRecipient["default"],
    rowKey: 'pawn.pawnId',
    handle: 'messageLogByRecipient',
    columns: [{
      name: 'user.username',
      label: 'Username',
      sort: true,
      filter: true
    }, {
      name: 'pawn.pawnId',
      label: 'Recipient ID',
      sort: true,
      filter: true
    }, {
      name: 'pawn.roleName',
      label: 'Role',
      sort: true,
      filter: true
    }, {
      name: 'parentGroup.anyGroup.group.label',
      label: 'Group',
      sort: true,
      filter: true
    }, {
      name: 'messageCount',
      label: '# Messages',
      sort: true,
      filter: true
    }, {
      name: 'messageSummary.minDate',
      label: 'First message',
      width: '170px',
      sort: true,
      filter: true,
      filterSettings: {
        type: 'date'
      }
    }, {
      name: 'messageSummary.maxDate',
      label: 'Latest message',
      width: '170px',
      sort: true,
      filter: true,
      filterSettings: {
        type: 'date'
      }
    }]
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdTabletop["default"], {
    handle: "messageLog",
    saveState: true,
    views: [{
      handle: 'messageLogByMessage',
      title: 'Message Log - by Message',
      table: byMessage
    }, {
      handle: 'messageLogByRecipient',
      title: 'Message Log - by Recipient',
      table: byRecipient
    }]
  }));
};
var _default = exports["default"] = {
  name: 'messagelog',
  title: 'Message Log',
  content: messageLogTable()
};